module.exports = __webpack_public_path__ + "img/4f5fb81.webp";